import logo from "./logo.svg";
import "./App.css";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppHeader from "./component/Header/AppHeader";
import Footer from "./component/Finaloptical/Footer";
import Home from "./component/Home/home";
import Contact from "./component/Contact/Contact";
import Galleryoptics from "./component/Gallery/Galleryoptics";
import Multiplepructs from "./component/Multipleproducts/Multiplepructs";
import AnimatedCursor from "react-animated-cursor";
import AboutSection from "./component/About/AboutSection";
import AllServices from "./component/Services/AllServices";
import ScrollToTopButton from "./component/resuble/ScrollToTopButton";
import WelcomeMessage from "./component/resuble/WelcomeMessage";
// import Banner from './component/Banner/Banner';
// import AboutSection from './component/About/AboutSection';
// import ProductSlider from './component/Products/ProductSlider';

function App() {
  return (
    <>
      {/* <AppHeader />
      <Banner />
      <AboutSection />
      <ProductSlider /> */}
      {/* <AppDattaopticals />  */}
      
      <BrowserRouter>
        <AppHeader />
        <WelcomeMessage />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Galleryoptics />} />
          <Route path="/multiplepructs" element={<Multiplepructs />} />
          <Route path="/aboutus" element={<AboutSection />} />
          <Route path="/services" element={<AllServices />} />
        </Routes>
        <ScrollToTopButton />
        <Footer />
        <AnimatedCursor
          innerSize={10}
          outerSize={44} 
          // color="255, 147, 1"
          color="0, 0, 1"
          outerAlpha={0.1}
          innerScale={0.7}
          outerScale={1.4}
          showSystemCursor={true}
          trailingSpeed={8}
          innerStyle={{ borderRadius: "50%" }} 
          outerStyle={{
            borderRadius: "50%",
            border: "2px solid rgba(255, 147, 1, 0.3)",
          }} 
          />
      </BrowserRouter>
    </>
  );
}

export default App;
